import type { ExtraElementData, PunchListItem, Video } from '../types.ts/story';

/**
 * A video's punch list is stored inside `extraElementData`, one item per
 * element that carries `punchListData`. Ordered by transcript position.
 */
export function derivePunchList(
  extraElementData: Video['extraElementData'],
): PunchListItem[] {
  return Object.entries(extraElementData ?? {})
    .filter(([, element]) => (element as ExtraElementData).punchListData)
    .map(([id, element]) => ({
      id,
      ...(element as ExtraElementData | null)?.punchListData!,
    }))
    .sort(
      (a, b) =>
        a.transcriptPosition.startIndex - b.transcriptPosition.startIndex,
    );
}
